import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.CATEGORIES,
    method: "get",
    params,
  });
}

async function show(id) {
  return await request({
    url: `${ENDPOINT.CATEGORIES}/${id}`,
    method: "get",
  });
}

function create(data) {
  return request({
    url: ENDPOINT.CATEGORIES,
    method: "post",
    data,
  });
}

function update(data) {
  return request({
    url: `${ENDPOINT.CATEGORIES}/${data.id}`,
    method: "patch",
    data,
  });
}

async function updateMultiple(data) {
  return await request({
    url: `${ENDPOINT.CATEGORIES}`,
    method: "patch",
    data,
  });
}

function remove(data) {
  return request({
    url: `${ENDPOINT.CATEGORIES}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  show,
  create,
  update,
  updateMultiple,
  remove,
};
